"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareGranteeAvatar = void 0;
var _materialSymbols = require("@design/icons/material-symbols");
var _avatar = require("@design/ui/avatar");
var _utils = require("@common/components/share/utils");
var _jsxRuntime = require("react/jsx-runtime");
var ShareGranteeAvatar = exports.ShareGranteeAvatar = function ShareGranteeAvatar(_ref) {
  var grantee = _ref.grantee,
    size = _ref.size;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.Avatar, {
    size: size,
    "data-sentry-element": "Avatar",
    "data-sentry-component": "ShareGranteeAvatar",
    "data-sentry-source-file": "share-grantee-avatar.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarFallback, {
      className: "bg-background-subtle text-foreground-tertiary",
      "data-sentry-element": "AvatarFallback",
      "data-sentry-source-file": "share-grantee-avatar.tsx",
      children: grantee.kind === "user" ? (0, _utils.getInitials)(grantee.user) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.GroupIcon, {})
    })
  });
};